import { useQuery } from '@tanstack/react-query';
import { useAPIErrorHandler } from '../../useAPIErrorHandler';
import { searchRenewalSubmissions } from '../../../../api/submissions/submissions.api';
import { getData } from '../../../../utils/functional/fp';

useSearchRenewalSubmissions.QUERY_KEY_TOPIC = 'renewal-submissions';
export function useSearchRenewalSubmissions(filters: Record<string, unknown>) {
  const apiErrorHandler = useAPIErrorHandler();

  return useQuery({
    queryKey: [useSearchRenewalSubmissions.QUERY_KEY_TOPIC, { filters }],
    queryFn: () => searchRenewalSubmissions({ params: filters }).then(getData),
    onError: apiErrorHandler('Unable to fetch renewal submissions'),
  });
}
